var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.licenseKey && _vm.licenseData
        ? _c("div", { staticClass: "text-right" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-outline-primary",
                attrs: { href: "javascript:;" },
                on: { click: _vm.logout },
              },
              [_vm._v("Abmelden")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.licenseKey
        ? _c("login", {
            attrs: { "lic-tool-root": _vm.licToolRoot },
            on: { login: _vm.login },
          })
        : _vm.licenseData && "pending" in _vm.licenseData
        ? _c("div", [
            _c("div", { staticClass: "alert alert-info" }, [
              _c("div", [
                _c("span", { staticClass: "fa fa-spin fa-spinner" }),
                _vm._v("\n            Lizenzdaten werden geladen\n          "),
              ]),
            ]),
          ])
        : _vm.licenseData && "error" in _vm.licenseData
        ? _c("div", [
            _c("div", { staticClass: "alert alert-danger" }, [
              _c("div", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.licenseData.error) +
                    "\n          "
                ),
              ]),
            ]),
          ])
        : _vm.licenseData
        ? _c(
            "div",
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("h2", [
                      _vm._v(
                        "Ihr Softwareprodukt: " +
                          _vm._s(_vm.licenseData.product)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card card-body mb-4" }, [
                      _c("p", [_vm._v(_vm._s(_vm.licenseData.restriction))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("Ihr zuständiger Berater bei der GRB: "),
                        _c("span", { staticClass: "highlight" }, [
                          _vm._v(_vm._s(_vm.licenseData.consultant)),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    !("lastDownload" in _vm.licenseData) ||
                    !_vm.licenseData.lastDownload.version
                      ? _c("div", { staticClass: "alert alert-info" }, [
                          _c("div", [
                            _vm._v(
                              "\n                    Sie haben die Software bisher nicht über diese Lizenzverwaltung herunter geladen. Laden Sie die Software immer hier herunter, um Ihre aktuelle Version hier einsehen zu können.\n                  "
                            ),
                          ]),
                        ])
                      : _c(
                          "p",
                          [
                            _vm._v(
                              "\n                    Sie haben zuletzt die "
                            ),
                            _c("font", { staticClass: "customer-data" }, [
                              _vm._v(
                                "Version " +
                                  _vm._s(_vm.licenseData.lastDownload.version)
                              ),
                            ]),
                            _vm._v(" herunter geladen.\n                "),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _vm.getUrlVars()["myVersion"]
                      ? _c("p", [
                          _vm._v(
                            "\n                    Ihre derzeit installierte Version ist die " +
                              _vm._s(_vm.getUrlVars()["myVersion"]) +
                              "\n                "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.productVersions.length > 0 &&
                    (_vm.productVersions[0].name !==
                    _vm.getUrlVars()["myVersion"]
                      ? _vm.getUrlVars()["myVersion"]
                      : _vm.licenseData.lastDownload.version)
                      ? _c("div", { staticClass: "alert alert-info" }, [
                          _c("div", [
                            _vm._v(
                              "\n                     Bitte aktualisieren Sie auf die aktuelle Version!\n                   "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.licenseData.download
                      ? _c("div", [
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.licenseData.download.notes),
                            },
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-right" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-outline-primary",
                                attrs: {
                                  href:
                                    _vm.licToolRoot +
                                    "/" +
                                    _vm.licenseData.download.link,
                                },
                              },
                              [
                                _vm._v(
                                  " Download Version " +
                                    _vm._s(_vm.licenseData.download.version)
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.productVersions.length
                      ? _c("div", { staticClass: "text-center" }, [
                          _c("span", {
                            staticClass: "fa fa-3x fa-spin fa-spinner",
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.productVersions, function (version) {
                      return _c(
                        "div",
                        {
                          key: version.name,
                          staticClass: "productversion-wrapper",
                        },
                        [
                          _c("h3", { staticClass: "d-flex d-space-between" }, [
                            _c("span", [_vm._v(_vm._s(version.name))]),
                            _vm._v(" "),
                            _c("small", { staticClass: "ml-auto" }, [
                              _vm._v(
                                _vm._s(_vm.moment(version.date).format("LL"))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            _vm._l(version.changelog, function (change, i) {
                              return _c("li", { key: i }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(change) +
                                    "\n                        "
                                ),
                              ])
                            }),
                            0
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("h2", [_vm._v(" Hinterlegte Kontaktdaten ")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        " Bitte halten Sie die hier hinterlegten Daten immer auf dem aktuellen Stand, damit unser Support Sie bei Problemen schnell kontaktieren kann."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        " Insbesondere werden diese Daten benötigt, um Ihnen Ihre verlängerten Lizenzen zukommen zu lassen."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [_c("strong", [_vm._v(" Fachlicher Kontakt ")])]),
                    _vm._v(" "),
                    _c("contact", {
                      attrs: { contact: _vm.licenseData.contact },
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-1" }, [
                      _c("strong", [_vm._v(" Kontakt der IT-Abteilung ")]),
                    ]),
                    _vm._v(" "),
                    _c("contact", {
                      attrs: { contact: _vm.licenseData.itContact },
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "text-right",
                        staticStyle: { "margin-top": "15px" },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-outline-primary",
                            attrs: { href: "javascript:;" },
                            on: { click: _vm.editContact },
                          },
                          [_vm._v("Daten ändern")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("h2", [_vm._v(" Ausgestellte Lizenzen ")]),
                    _vm._v(" "),
                    _vm.licenseData.renewable
                      ? _c("div", { staticClass: "alert alert-info mt-2" }, [
                          _c("div", [
                            _c("p", [
                              _vm._v(" Ihre Lizenz kann verlängert werden. "),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "text-right" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-outline-primary",
                                  attrs: { href: "javascript:;" },
                                  on: { click: _vm.renew },
                                },
                                [_vm._v(" Lizenz verlängern ")]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "list-group" },
                      _vm._l(_vm.licenseData.licenses, function (item, i) {
                        return _c(
                          "div",
                          {
                            key: i,
                            staticClass: "list-group-item",
                            class: ["license-state-" + item.state],
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.moment(item.created).format("LL")) +
                                "\n                        bis\n                        " +
                                _vm._s(
                                  _vm.moment(item.valid_until).format("LL")
                                ) +
                                "\n\n                        "
                            ),
                            "max_org_unit" in item && item.max_org_unit > 0
                              ? _c("div", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.max_org_unit) +
                                      " Standorte\n                        "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.state == "active" || item.state == "renewable"
                              ? _c("div", { staticClass: "text-right" }, [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName: "v-b-modal.licenseHelp",
                                          modifiers: { licenseHelp: true },
                                        },
                                      ],
                                      staticClass: "btn btn-outline-primary",
                                      attrs: {
                                        href: _vm.generateDownloadLink(item),
                                      },
                                    },
                                    [_vm._v("Lizenzdatei herunterladen")]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("edit-contacts", {
                ref: "editContact",
                attrs: {
                  "license-key": _vm.licenseKey,
                  "license-data": _vm.licenseData,
                  "lic-tool-root": _vm.licToolRoot,
                },
                on: {
                  updated: function ($event) {
                    _vm.updateCount = _vm.updateCount + 1
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "licenseHelp",
                    title: "Lizenzdownload gestartet",
                    "ok-only": "",
                    "ok-title": "Anleitung schließen",
                    size: "lg",
                  },
                },
                [
                  _c("p", [
                    _vm._v(
                      "Der Lizenzdownload wurde gestartet. Bitte speichern sie die Datei lokal"
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.licenseData.product == "riscage"
                    ? _c("license-upload-riscage")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.licenseData.product == "riskop"
                    ? _c("license-upload-riskop")
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _c("div", { staticClass: "alert alert-danger" }, [
            _c("div", [
              _vm._v(
                "\n        Die angegebene Lizenz Id ist nicht valide.\n      "
              ),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }